import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { createQueryClient, setQueryClient } from "./libs/query-client";
import { getTenantSlug } from "./libs/utils";
// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
const router = createRouter({
  routeTree,
});

// React Query client initialization
const queryClient = createQueryClient();
// グローバル参照用にクエリクライアントを設定
setQueryClient(queryClient);

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
// biome-ignore lint/style/noNonNullAssertion: <explanation>
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

function getSentryEnv() {
  const slug = getTenantSlug();
  const appEnv = import.meta.env.VITE_APP_ENV;
  return `${slug}-${appEnv}`;
}

if (import.meta.env.VITE_ENABLE_SENTRY === "true") {
  Sentry.init({
    dsn: "https://0755aad840795d7d737bfcf46d319dca@o4504292631707648.ingest.sentry.io/4505941762572288",
    integrations: [Sentry.tanstackRouterBrowserTracingIntegration(router)],

    // パフォーマンスの計測は行わない
    tracesSampleRate: 0,
    // エラーのないセッションでのリプレイは不要なので無効化
    replaysSessionSampleRate: 0,
    // すべてのエラーで replay を有効にする
    replaysOnErrorSampleRate: 1.0,

    // 通信環境起因のエラーは通知しない
    ignoreErrors: [
      "Failed to fetch",
      "Load failed",
      "NetworkError when attempting to fetch resource",
      "The Internet connection appears to be offline",
    ],

    environment: getSentryEnv(),
  });
}
